import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useAuthenticationPreflight } from "Components/Generic/Authentication";
import { hasElements } from "Utils/Array";
import { hasEveryRelevantProject } from "Utils/Relevance";
import { addressValidationStart } from "Store/Actions";
import { selectSelectedOrActiveProjectIds, selectSelectedOrActiveProjects } from "../../../Store/Selectors/Projects";
import { IAction } from "./IAction";

export function useAddressValidation(): [boolean, IAction] {
  const dispatch = useDispatch();
  const { preflightAuthentication } = useAuthenticationPreflight();
  const selectedProjects = useSelector(selectSelectedOrActiveProjects);
  const selectedProjectIds = useSelector(selectSelectedOrActiveProjectIds);
  const allowAddressValidation = hasElements(selectedProjects) && selectedProjects.length <= 10 && hasEveryRelevantProject(selectedProjects);

  const onAddressValidation = useCallback(async () => {
    if (!allowAddressValidation) {
      return;
    }

    await preflightAuthentication();
    dispatch(addressValidationStart(selectedProjectIds));
  }, [allowAddressValidation, dispatch, preflightAuthentication, selectedProjectIds]);

  return [allowAddressValidation, onAddressValidation];
}
